/** 主包 appId，接口走绝对地址 */
export const GROUP_APP_ID = 984582;

/**
 * 浏览器侧由 head 内联脚本最早写入 window.__H5R_RESOLVED_APP_ID__；
 * 构建/无 window 时回退主包 id。
 */
export function getAppId(): number {
    if (typeof window !== 'undefined') {
        const resolved = window.__H5R_RESOLVED_APP_ID__;
        if (resolved) {
            return resolved;
        }
    }
    return GROUP_APP_ID;
}
